import { onMounted, ref, watch } from '@vue/composition-api'
import axios from '@/libs/axios'
import moment from '@/libs/moment'

export const dateFrom = ref(
  moment()
    .startOf('year')
    .format('YYYY-MM-DD')
)
export const dateTo = ref(
  moment()
    .endOf('year')
    .format('YYYY-MM-DD')
)
export const dashboardFilterRequestCount = ref(0)
export const dashboardFiltering = ref(false)

function beginFilterRequest() {
  dashboardFilterRequestCount.value += 1
  dashboardFiltering.value = true
}

function finishFilterRequest() {
  dashboardFilterRequestCount.value = Math.max(
    0,
    dashboardFilterRequestCount.value - 1
  )
  if (dashboardFilterRequestCount.value === 0) {
    dashboardFiltering.value = false
  }
}

async function runTrackedRequest(executor, { isFilter = false } = {}) {
  if (isFilter) beginFilterRequest()
  try {
    return await executor()
  } finally {
    if (isFilter) finishFilterRequest()
  }
}

export function resetDate() {
  dateFrom.value = moment()
    .startOf('year')
    .format('YYYY-MM-DD')
  dateTo.value = moment()
    .endOf('year')
    .format('YYYY-MM-DD')
}

export function MostViewedProduct() {
  const data = ref([])
  async function getMostViewedProduct(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `/product-view-log/take/all/date.from/${dateFrom.value}/date.to/${dateTo.value}/case/dashboard`
          )
          .then(res => {
            data.value = res.data.data.records
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getMostViewedProduct(false))
  watch(dateFrom, () => getMostViewedProduct(true))
  watch(dateTo, () => getMostViewedProduct(true))

  return {
    data,
  }
}

export function Top5Unit() {
  const data = ref([])
  async function getTop5Unit(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `/visitor-log/take/all/date.from/${dateFrom.value}/date.to/${dateTo.value}/case/topunit`
          )
          .then(res => {
            data.value = res.data.data.records
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getTop5Unit(false))
  watch(dateFrom, () => getTop5Unit(true))
  watch(dateTo, () => getTop5Unit(true))

  return {
    data,
  }
}

export function Top5User() {
  const data = ref([])
  async function getTop5Unit(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `/visitor-log/visitor?start=${dateFrom.value}&end=${dateTo.value}`
          )
          .then(res => {
            data.value = res.data
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getTop5Unit(false))
  watch(dateFrom, () => getTop5Unit(true))
  watch(dateTo, () => getTop5Unit(true))

  return {
    data,
  }
}

export function Rating() {
  const data = ref([])
  async function getRating(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `/rating/case/result-admin/take/all/date.from/${dateFrom.value}/date.to/${dateTo.value}`
          )
          .then(res => {
            data.value = res.data.data.records
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getRating(false))
  watch(dateFrom, () => getRating(true))
  watch(dateTo, () => getRating(true))

  return {
    data,
  }
}

export function Visitor() {
  const data = ref(0)
  async function getVisitor(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `visitor-log/visitor?start=${dateFrom.value}&end=${dateTo.value}`
          )
          .then(res => {
            data.value = res.data.length
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getVisitor(false))
  watch(dateFrom, () => getVisitor(true))
  watch(dateTo, () => getVisitor(true))

  return {
    data,
  }
}

export function Views() {
  const data = ref(0)
  async function getViews(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(`visitor-log/views?start=${dateFrom.value}&end=${dateTo.value}`)
          .then(res => {
            data.value = res.data
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getViews(false))
  watch(dateFrom, () => getViews(true))
  watch(dateTo, () => getViews(true))

  return {
    data,
  }
}

export function PCC() {
  const data = ref([])
  async function getPCC(isFilter = false) {
    return runTrackedRequest(
      async () =>
        axios
          .get(
            `/pcc/browse/take/all/date.from/${dateFrom.value}/date.to/${dateTo.value}`
          )
          .then(res => {
            data.value = res.data.data.records
            return res
          })
          .catch(err => console.error(err)),
      { isFilter }
    )
  }

  onMounted(() => getPCC(false))
  watch(dateFrom, () => getPCC(true))
  watch(dateTo, () => getPCC(true))

  return {
    data,
  }
}
